import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form, FieldArray, getIn } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import IconButton from '@mui/material/IconButton';
import CustomSelect from "../CustomComponents/CustomSelect";
import { PropListItem } from "../CustomComponents/PropListItem";
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from "@mui/styles";
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import {logger,checkAuthentication} from '../../utils';
import { FormGroup } from "@material-ui/core";

const pageStyles = makeStyles(theme => ({
    container: {
        display: "flex",
        flexFlow: "column wrap",
        gap: "0 20px",
        height: 400,
        overflow: "auto"
    },
    item: {
        maxWidth: "200px"
    }
}));

export default function EditTaskPropDialog({ handleEditCallback, data }) {
    /*  logger({
        "EditData": data
    })*/
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [dataRequest, setDataRequest] = React.useState(false);
    const [addOption, setAddOption] = React.useState(false);
    const [optionList, setOptionList] = React.useState([]);
    const [NewOption, setNewOption] = React.useState([]);
    const [NewOptionActive, setNOActive] = React.useState([true]);
    const timerRef = React.useRef(null);
    const classes = pageStyles();
    const [showAllOptions, setShowAllOptions] = React.useState(false);

    const [typeChoices, setTypeChoices] = React.useState([
        { label: 'Dropdown', value: '1' },
        { label: 'Text Field', value: '0' },
    ])

    const validFormSchema = Yup.object({
        variable: Yup
            .string('Enter a name for this Task variable')
            .required('Name is required'),
        format: Yup
            .string('Please enter a Regualr Expresion describing the format if available.'),            
        type: Yup
            .string('Please enter the type of variable being created.')
            .required('Type is required'),
        IsActive: Yup
            .boolean(),
        /*newOption: Yup
            .string('Add a new Option')
            .required('Name is required'),
        newOptionActive: Yup
            .boolean(),*/
        propList: Yup.array().of(
            Yup.object().shape({
                Name: Yup.string().required("variable Name is requried"),
                IsActive: Yup.boolean(),
            //    IsDelete: Yup.boolean()
            })
        )
       
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            ID: data.ID,
            Name: values.variable,
            Validation: values.format,
            IsDropdown: values.type,
            IsActive: values.IsActive ? 1 : 0,
            PropList: values.propList
        };
     //   logger(`trigger`,msg)
     //   logger(`proplist out`, values)
        handleEditCallback(msg);
        handleClose();
        
    })

    const handleClickOpen = () => {
        setRefresh(true)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setRefresh(false);
        setDataRequest(false)
    };

    const handleAdd = () => {
     //   logger(`AddButtonprops`, props.values)
        setNewOption('')
    };

    const getData = async (data) => {
        await fetch(`api/task_prop_item/${data.ID}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                const choices = [];
                json.forEach((element, index) => choices.push({ Num: index, ID: element.ID, Name: element.Name, IsActive: element.IsActive ? true : false }))
        //        logger(`json`, json)
        //        logger(`choices`, choices)
                setOptionList(choices)
            })

            .then(choices => {
                if (!optionList[0] && data.IsDropdown == 1) {
                //    timerRef.current = setTimeout(() => {
                //    logger(`if No OL`, optionList)
                //        logger(`No OL Choices`, choices)
                        setIsLoaded(false)
                        setRefresh(true)
                  //  }, 2000);
                } else {
                 //   logger(`OL1 passed`)
                    setDataRequest(true)
                    setIsLoaded(true)
                //    logger(`init`, initialValues)
                }
            })
    }

    const initialValues = {
        variable: data.Name,
        format: data.Validation,
        type: data.IsDropdown,
        IsActive: data.IsActive ? true : false,
        newOption: NewOption,
        newOptionActive: NewOptionActive ? true : false, 
        propList: optionList
    }
    const checkList = () => {
        if (OptionList[1]) {
        //    logger(`checkList`, OptionList)
            setIsLoaded(true)
        }
    }
    
    React.useEffect(() => {
		checkAuthentication();
  // logger(`optionList`, [optionList])
        if (refresh) {
      //      logger(`refresh data`, data)

            if (!dataRequest) {
          //      logger(`making data request`,data)
                getData(data)
                
            }
           /* if (!isLoaded) {
                logger(`checking Optionlist`, optionList)
                
            }*/
             
        }
       
      /*  if (isLoaded) {
            setRefresh(false)
        }*/
        setRefresh(false)
    })
    return (
       
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Tooltip title="Edit Entry" placement="top-end">
                <IconButton
                    variant="contained"
                    onClick={handleClickOpen}
                    
                >
                    <BorderColorRoundedIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validationSchema={validFormSchema}
                        validateOnChange={false}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Edit Task variable
                                        </Typography>
                                        {(data.IsDropdown == 1) &&
                                        <FormGroup>
                                            <FormControlLabel control={
                                                    <Checkbox
                                                    checked={showAllOptions}
                                                    labelStyle={{ color: 'white' }}
                                                    iconStyle={{ fill: 'white' }}
                                                    inputStyle={{ color: 'white' }}
                                                    style={{ color: 'white' }}
                                                    onClick={() => { setShowAllOptions(!showAllOptions) }}
                                                    />
                                                }
                                                label="Include Inactive Options"
                                            />
                                        </FormGroup>}
                                       <Button autoFocus color="inherit" onClick={ props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar> 
                                <DialogTitle>Task Info:</DialogTitle>
                                <Grid container spacing={1}  pl={1}>
                                    <Grid item xs={3}>
                                  <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>                                       
                                        <TextField
                                            name='variable'
                                            id="outlined-taskProp"                                
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                           value={props.values.variable}
                                            error={props.touched.variable && Boolean(props.errors.variable)}
                                            helperText={props.touched.variable && props.errors.variable}
                                            label="Variable name"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>                                        
                                        <TextField
                                            name='format'
                                            id="outlined-format"                                
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.format}
                                            error={props.touched.format && Boolean(props.errors.format)}
                                            helperText={props.touched.format && props.errors.format}
                                            label="Format"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl disabled sx={{ m: 1, width: 240 }}>
                                        <InputLabel htmlFor="outlined-propEntryType">Prop entry type</InputLabel>
                                            <CustomSelect
                                                name="type"
                                                id="outlined-propEntryType"
                                                options={typeChoices}
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                value={props.values.type}
                                                error={props.touched.type && Boolean(props.errors.type)}
                                                helperText={props.touched.type && props.errors.type}
                                                label="Variable entry type"
                                            />
                                    </FormControl>
                                </div>
                            
                                  <div>
                                    <FormControl sx={{ m: 1}}>
                                        <FormControlLabel
                                            name="IsActive"
                                            label="Active"
                                            control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                        </div>                                       
                                     
                                    </Grid>
                                    <Grid item xs={8}> 
                                   
                                    {(!isLoaded) ?

                                            <Box sx={{ height: 300 }}>
                                                {(data.IsDropdown == 1) &&
                                                    <Fade
                                                        in={(!isLoaded)}
                                                        style={{
                                                            transitionDelay: isLoaded ? '800ms' : '0ms',
                                                        }}
                                                        unmountOnExit
                                                    >
                                                        <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
                                                            <CircularProgress color="secondary" />
                                                            <CircularProgress color="success" />
                                                            <CircularProgress color="inherit" />
                                                        </Stack>
                                                    </Fade>}
                                        </Box>
                                        :
                                        <Box>
                                                {(data.IsDropdown == 1) &&
                                                    <FieldArray name="propList">
                                                        {({ push, remove }) => (
                                                            <div>
                                                                <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                                                    <Typography sx={{ ml: 2, flex: 1 }} variant="h7" component="div">
                                                                        Options  for  {props.values.variable} Variable:
                                                                    </Typography>
                                                                </div>
                                                                <Box className={classes.container} >
                                                                    <List dense className={classes.container}
                                                                        sx={{
                                                                            //   maxWidth: 200,
                                                                            bgcolor: 'background.paper',
                                                                           
                                                                        }}>         

                                                                        {props.values.propList.map((bob, index) => {
                                                                            const labelId = `DropDownProperties-label-${index}`;
                                                                            const name = `propList[${index}].Name`;
                                                                            //    const IsDelete = `propList[${index}].IsDelete`;
                                                                            const IsActiveName = `propList[${index}].IsActive`;
                                                                            //   logger(`propList`, props.values.propList)
                                                                            //   logger(`Listprops`, bob)
                                                                            //  logger(`index`, index)
                                                                            //  logger(`name`, name)
                                                                            if (bob.IsActive || showAllOptions) {
                                                                                return (
                                                                                    <ListItem
                                                                                        className={classes.item}
                                                                                        //  label="Prop Name"
                                                                                        name={name}
                                                                                        value={bob.Name}
                                                                                        key={bob.Num}
                                                                                        // key={value.value}
                                                                                        disablePadding
                                                                                    >
                                                                                        <Tooltip title="Active in Dropdown" placement="top-end">
                                                                                            <ListItemButton onClick={props.handleChange}>                                                                                       
                                                                                                <Checkbox
                                                                                                    edge="start"
                                                                                                    checked={bob.IsActive}
                                                                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                                                                    name={IsActiveName}
                                                                                                /> 
                                                                                                <ListItemText id={labelId} primary={bob.Name} />
                                                                                            </ListItemButton>
                                                                                        </Tooltip>
                                                                                    </ListItem>
                                                                                );
                                                                            }
                                                                        })}
                                                                    </List>
                                                                </Box>
                                                                <Grid container alignItems={"center"}> 
                                                                    <Grid item xs={4}>
                                                                        <FormControl sx={{ m: 1, width: 240 }}>                                                                              
                                                                            <TextField
                                                                                margin="normal"
                                                                                id="outlined-newOption"  
                                                                                variant="outlined"
                                                                                label="New Option"
                                                                                name='newOption'
                                                                                value={props.values.newOption}
                                                                                required
                                                                                helperText={props.errors.name}
                                                                                error={Boolean(props.errors.name)}
                                                                                onChange={props.handleChange}
                                                                                onBlur={props.handleBlur}
                                                                            />
                                                                        </FormControl>
                                                                    </Grid>
                                                                    <Grid item xs={2} ml={2}> 
                                                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                                                            <FormControlLabel
                                                                                label="Active"
                                                                                control={<Checkbox checked={props.values.newOptionActive} />}
                                                                                name='newOptionActive'
                                                                                onChange={props.handleChange} 
                                                                            />
                                                                            <Tooltip title="2-step process: add any items to list, then SAVE" placement="top-end">
                                                                                <IconButton color="primary" sx={{ p: '10px' }} aria-label="AddNewOption"
                                                                                    onClick={() => {
                                                                                        //setNewOption(props.values.newOption)
                                                                                        //setNOActive(props.values.newOptionActive)
                                                                                        push({ Num: props.values.propList.length, ID: 0, Name: props.values.newOption, IsActive: props.values.newOptionActive })
                                                                                        props.values.newOption = null;
                                                                                    }}>
                                                                                    <AddCircleOutlineIcon />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>

                                                                
                                                            </div>


                                                        )}
                                                    </FieldArray>
                                                }
                                          </Box>
                                        }
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
                
            </Dialog></MuiThemeProvider>
        </div>
    );
}